import React from "react";
import {
    Stack,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import Iconify from "./iconify";
import { getUserPermissions } from "src/utils/permissionsUtils";

const StagePeriodSelector = ({
    stagePeriods,
    selectedStagePeriodId,
    onPeriodChange,
    onEditStagePeriod,
}) => {
    const { isViewer } = getUserPermissions();

    if (!stagePeriods) {
        return null;
    }

    return (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mb={3}>
            <FormControl fullWidth>
                <InputLabel id="week-select-label">Stage Period</InputLabel>
                <Select
                    labelId="week-select-label"
                    id="week-select"
                    value={selectedStagePeriodId}
                    label="Select Week"
                    onChange={onPeriodChange}
                >
                    {stagePeriods.map((period) => (
                        <MenuItem
                            key={period.stagePeriodId}
                            value={period.stagePeriodId}
                            sx={{
                                opacity: period.isVisible ? 1 : 0.5,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <span>
                                {period.stagePeriodId === "all"
                                    ? "All"
                                    : `${period.name} (${new Intl.DateTimeFormat("en-US", {
                                        month: "short",
                                    }).format(new Date(period.startDate))} ${new Date(
                                        period.startDate
                                    ).getDate()} - ${new Intl.DateTimeFormat("en-US", {
                                        month: "short",
                                    }).format(new Date(period.endDate))} ${new Date(
                                        period.endDate
                                    ).getDate()})`}
                            </span>
                            {!period.isVisible && period.stagePeriodId !== "all" && (
                                <span
                                    style={{ fontSize: "0.8em", color: "#999" }}
                                >{` (Hidden)`}</span>
                            )}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {!isViewer && (
                <Button
                    variant="contained"
                    startIcon={<Iconify icon="eva:edit-outline" />}
                    disabled={selectedStagePeriodId === "all"}
                    onClick={onEditStagePeriod}
                >
                    Edit
                </Button>
            )}
        </Stack>
    );
};

export default StagePeriodSelector;